class BankTransactionService {
  constructor(parentComponent) {
    this.bankTransactionsURL = parentComponent.$root.urls.admin_bank_transactions
    this.companiesURL = parentComponent.$root.urls.admin__load_companies
    this.httpClient = parentComponent.$http
    this.token = parentComponent.$cookies.get('api_token')
  }

  async fetchBankTransactions(companies, props) {
    const {
      fromDate,
      toDate,
      lastId,
      filterUnmatched,
      filterRefunded,
      filterCompanyId,
      filterSubjectId,
      filterCurrency,
      filterId,
      perPage
    } = props

    const params = {
      last_id: lastId,
      no_scheduled: filterUnmatched,
      refunded: filterRefunded,
      company_id: filterCompanyId,
      subject_id: filterSubjectId,
      currency: filterCurrency,
      id: filterId,
      per_page: perPage
    }

    Object.keys(params).forEach((k) => params[k] === null && delete params[k])

    if(fromDate) {
      params.from = fromDate.toISOString()
    }

    if(toDate) {
      params.to = toDate.toISOString()
    }

    const response = await this.httpClient.get(
      this.bankTransactionsURL,
      {params, headers: { Authorization: `Bearer ${this.token}` }}
    )

    if(response.status === 401) {
      throw new Error("Unauthorized")
    }

    if(response.status !== 200) {
      throw new Error("Internal Server Error")
    }

    const responseBankTransactions = response.body.data
    const companyIds = new Set()

    responseBankTransactions.forEach(bt => {
      if(bt.scheduled_bank_transaction && bt.scheduled_bank_transaction.company_id) {
        companyIds.add(bt.scheduled_bank_transaction.company_id)
      }
    })

    const setCompanies = new Set(companies.map(e => e.id))

    for(const element of setCompanies) {
      companyIds.delete(element)
    }

    if(companyIds.size > 0) {
      const payload = { company_ids: companyIds }
      const companiesResponse = await this.fetchCompanies(payload)

      companies = companies.concat(companiesResponse)
    }

    const bankTransactions = responseBankTransactions.map(bt => {
      if(bt.scheduled_bank_transaction) {
        const company_id = bt.scheduled_bank_transaction.company_id
        bt.scheduled_bank_transaction.company = companies.find(c => c.id === company_id)
      }

      return bt
    })

    return { bankTransactions, companies }
  }

  async fetchCompanies(payload) {
    const response = await this.httpClient.post(
      this.companiesURL,
      payload,
      { headers: { Authorization: `Bearer ${this.token}` }}
    )

    if(response.status === 401) {
      throw new Error("Unauthorized")
    }

    if(response.status !== 200) {
      throw new Error("Internal Server Error")
    }

    return response.body.data
  }

}

export {BankTransactionService}



// WEBPACK FOOTER //
// ./src/shared/BankTransactionsService.js